import { AiFillApi, AiFillProduct } from "react-icons/ai";
import {
  MdDashboard,
  MdCategory,
  MdAcUnit,
  MdOutlineShoppingCartCheckout,
} from "react-icons/md";
import {
  FaUsers,
  FaCartPlus,
  FaUserPlus,
  FaArrowUpRightDots,
  FaRecycle,
  FaCartArrowDown,
} from "react-icons/fa";
import { FaCartFlatbedSuitcase, FaMoneyBill1Wave } from "react-icons/fa6";
import { SiMoneygram } from "react-icons/si";
import { CiSettings } from "react-icons/ci";
import { GiPayMoney } from "react-icons/gi";
import { HiUsers } from "react-icons/hi";
import { BsFillCartDashFill } from "react-icons/bs";
import { BsCartX } from "react-icons/bs";
import { TbTax, TbDeviceDesktopAnalytics } from "react-icons/tb";
import { IoMicOffCircle } from "react-icons/io5";
import { useContext } from "react";
import { UserContext } from "../components/context/UserContext";

export const SidebarItemLists = [
  {
    tile: "Dashboard",
    url: "/dashboard",
    icon: <MdDashboard />,
  },
  {
    tile: "Sale",
    url: "/sales",
    icon: <BsFillCartDashFill />,
  },
  {
    tile: "Customer",
    url: "/customers",
    icon: <FaUsers />,
  },
  {
    tile: "Purchase",
    url: "/purchase",
    icon: <FaCartFlatbedSuitcase />,
  },
  {
    tile: "Supplier",
    url: "/suppliers",
    icon: <FaUserPlus />,
  },
  {
    tile: "Product",
    url: "/products",
    icon: <AiFillProduct />,
  },
  {
    tile: "Category",
    url: "/categories",
    icon: <MdCategory />,
  },
  {
    tile: "Payment",
    url: "/payments",
    icon: <FaMoneyBill1Wave />,
  },
  {
    tile: "Expense",
    url: "/expenses",
    icon: <GiPayMoney />,
  },
  {
    tile: "Return/Refund",
    url: "#",
    icon: <SiMoneygram />,
    subMenu: [
      {
        title: "Sale Return",
        url: "/sale-return",
        icon: <FaCartArrowDown />,
      },
      {
        title: "Purchase Return",
        url: "/purchase-return",
        icon: <MdOutlineShoppingCartCheckout />,
      },
    ],
  },
  {
    tile: "Wastage",
    url: "/wastage",
    icon: <FaRecycle />,
  },
  {
    tile: "Report",
    url: "/reports",
    icon: <TbDeviceDesktopAnalytics />,
  },
  {
    tile: "Setting",
    url: "#",
    icon: <CiSettings />,
    subMenu: [
      {
        title: "Company",
        url: "/company-profile",
        icon: <IoMicOffCircle />,
      },
      {
        title: "Audit Log",
        url: "/audit-log",
        icon: <IoMicOffCircle />,
      },
      {
        title: "User",
        url: "/users",
        icon: <FaUsers />,
      },
      {
        title: "Tax",
        url: "/tax",
        icon: <TbTax />,
      },
      {
        title: "Unit",
        url: "/units",
        icon: <MdAcUnit />,
      },
      {
        title: "Permission",
        url: "/permission",
        icon: <AiFillApi />,
      },
    ],
  },
];
